import { FaThList, FaShoppingCart, FaLaptopHouse } from 'react-icons/fa'
import { BiImage } from 'react-icons/bi'
import { BsFillGiftFill } from 'react-icons/bs'
import solution_svg from '../../assets/Image/solution_svg.svg'
import { Schedule } from '../../Component'
const Solutions = () => {
    return (
        <>
            <div className='solution_main_div'>
                <div>
                    <div className='solution_list_icon_div'>
                        <FaThList />
                    </div>
                    <div className='solution_list_text_div'>
                        <h4>OUR</h4>
                        <b>WEB3 SOLUTIONS</b>
                    </div>
                </div>
                <div className='solution_inner_div1'>
                    <div className='solution_text_main_div'>
                        <div className='solution_list_text_div2' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='200'>
                            <h4>OUR</h4>
                            <b>SOLUTIONS</b>
                        </div>
                        <div className='solution_text_div'>
                            <p className='solution_p'>
                                Our services are designed to meet the unique needs of both traditional companies and Web3 native ones. Whether you're looking to create digital collectibles, develop NFT loyalty programs, or create unique Metaverse experiences. If this sounds overwhelming, we designed a blockchain onboarding program, empowering you and your team with the knowledge and skills you need to leverage blockchain technology
                            </p>
                            <p className='solution_p2'>
                                Additionally, we can help with launching NFT drops on existing marketplaces or create white-label solutions as well as design unique meta verse experiences that help you reach your audience and stand out from the competition. Explore our range of blockchain services and discover how we can help transform your business for the future.
                            </p>
                        </div>
                    </div>
                    <div className='solution_text_main_div2'>
                        <div>
                            <div className='solution_list_text_div3' data-aos="fade-left" data-aos-duration='1500' data-aos-delay='200'>
                                <h4>A WIDE RANGE OF</h4>
                                <b> WEB3 SOLUTIONS & EXPERIENCES</b>
                            </div>
                            <div className='solution_list_text_div4'>
                                <h4>Discover some potential </h4>
                                <b> Web3 products you could implement</b>
                            </div>
                            <div className='solution_svg_div'>
                                <img src={solution_svg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cards_main_div'>
                    <div className='card_inner_div'>
                        <div className='card_icon_div'>
                            <BiImage className='card_icon' />
                        </div>
                        <div className='card_h3_div'>
                            <h3>
                                DIGITAL COLLECTIBLES
                            </h3>
                        </div>
                    </div>
                    <div className='card_inner_div'>
                        <div className='card_icon_div'>
                            <FaShoppingCart className='card_icon' />
                        </div>
                        <div className='card_h3_div'>
                            <h3>
                                NFT MARKETPLACE
                            </h3>
                        </div>
                    </div>
                    <div className='card_inner_div'>
                        <div className='card_icon_div'>
                            <BsFillGiftFill className='card_icon' />
                        </div>
                        <div className='card_h3_div'>
                            <h3>
                                LOYALTY PROGRAM
                            </h3>
                        </div>
                    </div>
                    <div className='card_inner_div'>
                        <div className='card_icon_div'>
                            <FaLaptopHouse className='card_icon' />
                        </div>
                        <div className='card_h3_div'>
                            <h3>
                                METAVERSE EXPERIENCE
                            </h3>
                        </div>
                    </div>
                </div>
                <div className='schedule_main_div'>
                    <Schedule heading="CAN'T FIND THE" bold="PRODUCT YOU NEED?" heading2="Schedule a call or" bold2=' send us a message!' />
                </div>
            </div>
        </>
    )
}
export default Solutions